import Keycloak from 'keycloak-js';

// Extend window interface for runtime env config
declare global {
  interface Window {
    env?: {
      REACT_APP_KEYCLOAK_URL?: string;
      REACT_APP_KEYCLOAK_REALM?: string;
      REACT_APP_KEYCLOAK_CLIENT_ID?: string;
      REACT_APP_IAM_URL?: string;
      REACT_APP_PORTAL_URL?: string;
    };
  }
}

// Get environment variables from runtime config or build-time config
const getEnvVar = (key: string, defaultValue: string = ''): string => {
  // Try runtime config first (production)
  if (window.env && window.env[key as keyof typeof window.env]) {
    return window.env[key as keyof typeof window.env] || defaultValue;
  }
  // Fallback to build-time config (development)
  return (process.env[key] as string) || defaultValue;
};

// Keycloak configuration from environment variables
const keycloakConfig = {
  url: getEnvVar('REACT_APP_KEYCLOAK_URL', 'https://iam.dev.desp.space'),
  realm: getEnvVar('REACT_APP_KEYCLOAK_REALM', 'desp'),
  clientId: getEnvVar('REACT_APP_KEYCLOAK_CLIENT_ID', 'sencore-public'),
};

// Initialize Keycloak instance
const keycloak = new Keycloak(keycloakConfig);

// Check if Keycloak is properly configured
export const isKeycloakConfigured = (): boolean => {
  return !!(keycloakConfig.url && keycloakConfig.realm && keycloakConfig.clientId);
};

export default keycloak;
